// extracted by mini-css-extract-plugin
export default {"Virtual":"Virtual_Virtual__j1Xo-","left":"Virtual_left__srE-c","wrapper":"Virtual_wrapper__NmT-N"};